<template>
  <label :for="id" class="flex justify-between items-center">
    <span class="text-sm">
      <span v-html="label" class="pl-1 whitespace-no-wrap"></span>
    </span>
    <span class="flex items-center">
      <span
        class="pl-2 pr-1 text-xs text-right text-blue-500 cursor-pointer"
        v-tooltip="labelInfo"
        v-if="hasLabelInfo"
      >
        <font-awesome-icon icon="info-circle"></font-awesome-icon>
      </span>
      <span v-if="required" class="pl-2 pr-1 text-gray-500 text-xs">
        <font-awesome-icon icon="star-of-life" size="xs"></font-awesome-icon>
      </span>
    </span>
  </label>
</template>

<script>
export default {
  props: ["id", "label", "labelInfo", "required"],
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    hasLabelInfo() {
      if (
        this.labelInfo != "" &&
        this.labelInfo != undefined &&
        this.labelInfo != null
      ) {
        return true;
      }

      return false;
    },
  },
  mounted() {},
};
</script>

<style></style>
